var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('UserManagementLayout',[_c('PageHeader',{attrs:{"slot":"page-header","title":_vm.$t('access.user_list.header')},slot:"page-header"}),_c('UserManagementItem',{attrs:{"slot":"user-management-item"},slot:"user-management-item"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }